import type { PaymentGatewayDetails } from "../../types/form-types"
import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"


export default function useGateways() {
    const useGetPaymentGateways = ({batchId, partnerId}: {batchId: string, partnerId: string}) => {
		return useQuery({
			queryFn: async () => {
				const { data } = await api.get<PaymentGatewayDetails[]>(
					`/batches/${batchId}/partners/${partnerId}/gateways`,
				)
				return data
			},
			queryKey: ["get-payment-gateways", batchId, partnerId],
			enabled: Boolean(batchId && partnerId),
		})
	}

	return {
		useGetPaymentGateways,
	}
}